import React from "react";
import { CarouselSlider } from "./style";
import { getToken } from "../../lib/tokenManager";
import EventListener from "react-event-listener";
class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: this.props.current
    };
  }

  componentDidMount() {
    document.body.style.overflow = "hidden";
  }
  componentWillUnmount() {
    document.body.style.overflow = "auto";
  }
  changeSlide(pos) {
    const { files } = this.props;
    let status = this.state.show;
    if (pos === "next") {
      if (files.length > status + 1) {
        this.setState({
          show: status + 1
        });
      } else {
        this.setState({
          show: 0
        });
      }
    }
    if (pos === "prev") {
      if (status === 0) {
        this.setState({
          show: files.length - 1
        });
      } else {
        this.setState({
          show: status - 1
        });
      }
    }
  }
  src(file) {
    if (this.props.whitOutProject) {
      return (
        process.env.REACT_APP_API_URL +
        "/imagesWeb/" +
        file.id +
        "?access_token=" +
        getToken("accessToken")
      );
    } else if (file.id) {
      return (
        process.env.REACT_APP_API_URL +
        "/projects/" +
        localStorage.getItem("project_id") +
        "/imagesWeb/" +
        file.id +
        "?access_token=" +
        getToken("accessToken")
      );
    } else {
      return window.URL.createObjectURL(file);
    }
  }
  render() {
    const { files } = this.props;
    return (
      <CarouselSlider onClick={()=>this.props.close()}>
        <EventListener
          target="document"
          onKeyDown={e => {
            e.stopPropagation();
            if (e.keyCode === 39) {
              this.changeSlide("next");
            } else if (e.keyCode === 37) {
              this.changeSlide("prev");
            }
          }}
        />
        <div className="header">
          <i
            className="icon mapsa-close"
            onClick={() => {
              this.props.close();
            }}
          />
        </div>
        <div className="path">
          <div
            className="prev"
            onClick={e => {
              this.changeSlide("prev");
              e.stopPropagation();
            }}
          >
            <i className="icon mapsa-forward" />
          </div>
          <img src={this.src(files[this.state.show])} alt="مپسا" />
          <div
            className="next"
            onClick={e => {
              this.changeSlide("next");
              e.stopPropagation();
            }}
          >
            <i className="icon mapsa-left-arrow-chevron" />
          </div>
        </div>
        <div className="footer">
          {files.map((file, i) => (
            <div
              className="image-slider-file"
              key={i}
              onClick={e => {
                this.setState({
                  show: i
                });
                e.stopPropagation();
              }}
            >
              <img className="image-slider-img" src={this.src(file)} alt="" />
            </div>
          ))}
        </div>
      </CarouselSlider>
    );
  }
}
export default Modal;
